export default __webpack_public_path__ + "static/media/main_video.1029cb75.mp4";